import { ChangeDetectionStrategy, Component, computed, forwardRef } from '@angular/core';
import { NodeViewComponent } from '@examdojo/core/tiptap';
import { SolverComponent } from '@examdojo/solver';
import { v4 as uuid } from 'uuid';
import { Solver, SolverBlock } from '../../../model';
import { DragWithHandleOnlyDirective } from '../drag-with-handle-only.directive';
import { DEFAULT_SOLVER_PROPS } from './solver.model';

@Component({
  selector: 'dojo-solver-node',
  standalone: true,
  imports: [SolverComponent],
  templateUrl: './solver.component.html',
  hostDirectives: [DragWithHandleOnlyDirective],
  providers: [
    {
      provide: NodeViewComponent,
      useExisting: forwardRef(() => SolverNodeComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolverNodeComponent extends NodeViewComponent<SolverBlock> {
  readonly id = this.getProp('id');
  readonly name = this.getProp('name');
  readonly content = this.getProp('content');
  readonly slides = this.getProp('slides');

  readonly solver = computed<Solver>(() => ({
    name: this.name() ?? undefined,
    content: this.content() ?? undefined,
    slides: this.slides(),
  }));

  override getDefaults = (): SolverBlock => ({
    ...DEFAULT_SOLVER_PROPS,
    id: uuid(),
  });
}
